var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.browserType !== 'weixin')?_c('Overlay',{staticStyle:{"z-index":"2"},attrs:{"show":_vm.showShare},on:{"click":function($event){_vm.showShare = false}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }